module.exports = __webpack_public_path__ + "static/feature-a5f7c6bdb5ab2e1f884211d9247cf6c1.png";